/*

poornima 09/19/2022  2700912712  Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs.
sohel  10/15/2022  2700912712  Triggers ->Added Code Comments.
Suresh peddavoora 10/27/2022  2700912712 Removed class name for textfields and table.
Sohel 11/09/2022 2700912712  prepoulate Filter code.
Sohel 12/16/2022 2700912712 map Fields changes
Akhila 05/31/2023 2700912712 unsaved changes bug fixed
*/

import React from 'react';
import SearchRuleGroupContainer from './SearchRuleGroupContainer';

function SearchRuleGroup({
  handleClose,
  setValue,
  setBreCode,
  setResetData,
  dataReset,
  roleDataBre,
  setRoleDataBre,
  setRowData,
  setRowSelected,
  StepperFilter,
  setShowFilterData,
  setIsCopy,
  ruleGroupCode,
  setRuleGroupCode,
  setGroupId,
  setRuleGroupId,
  handleDirty,
}) {
  return (
    <>
      <div className={handleClose ? `col-12` : `mb-0`}>
        <SearchRuleGroupContainer
          handleClose={handleClose}
          setValue={setValue}
          dataReset={dataReset}
          roleDataBre={roleDataBre}
          setRoleDataBre={setRoleDataBre}
          setBreCode={setBreCode}
          setResetData={setResetData}
          setRowData={setRowData}
          setRowSelected={setRowSelected}
          StepperFilter={StepperFilter}
          setShowFilterData={setShowFilterData}
          setIsCopy={setIsCopy}
          ruleGroupCode={ruleGroupCode}
          setRuleGroupCode={setRuleGroupCode}
          setGroupId={setGroupId}
          setRuleGroupId={setRuleGroupId}
          handleDirty={handleDirty}
        />
      </div>
    </>
  );
}

export default SearchRuleGroup;
